<template>
  <div class="dropdown-container">
    <DropdownPrime 
      v-model="selectedValue" 
      :options="options" 
      optionLabel="Glosa" 
      optionValue="Id" 
      placeholder="Selecciona un Curso" 
      :class="{'p-invalid': mostrarErrores && error}" 
      v-bind:[tooltipDirective]="tooltip" 
      @change="emitSelection"
    />
    <small v-if="mostrarErrores && error" class="p-error">{{ error }}</small>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import CursoService from '@/services/CursoService'; // Importa el servicio

export default {
  components: {
  },
  props: {
    mostrarErrores: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    modelValue: {
      type: Number, // Cambiado a Number para manejar solo un valor
      default: null
    }
  },
  setup(props, { emit }) {
    const options = ref([]);
    const selectedValue = ref(props.modelValue); // Inicializa como un único valor

    const fetchOptions = async () => {
      try {
        const response = await CursoService.get(); // Llama al método getCursos
        options.value = response.data; // Asegúrate de que la respuesta tenga la estructura correcta
      } catch (error) {
        console.error('Error al cargar opciones:', error);
      }
    };

    const emitSelection = () => {
      const ccc=[];
      ccc.push(selectedValue.value);
      emit('update:modelValue', ccc);
    };

    onMounted(() => {
      fetchOptions();
    });

    return {
      options,
      selectedValue,
      emitSelection
    };
  }
}
</script>

<style scoped>
.dropdown-container {
  margin-bottom: 1rem;
}
</style>
